import { useNavigate } from 'react-router-dom';
import { useScrollReveal, getRevealStyle } from '@/hooks/useScrollReveal';

const featuredChannels = [
  {
    category: '線上書店',
    name: '博客來',
    desc: '瀏覽機曜文化品牌書目',
    url: 'https://www.books.com.tw/web/sys_puballb/books/?pubid=daiho45',
  },
  {
    category: '線上書店',
    name: '誠品',
    desc: '搜尋機曜文化事業有限公司出版品',
    url: 'https://www.eslite.com/search?keyword=%E6%A9%9F%E6%9B%9C%E6%96%87%E5%8C%96%E4%BA%8B%E6%A5%AD%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8',
  },
  {
    category: '線上書店',
    name: '金石堂',
    desc: '瀏覽機曜文化出版品列表',
    url: 'https://www.kingstone.com.tw/bookpublish/publist/25015/',
  },
  {
    category: '經銷出版社',
    name: '崧博出版',
    desc: '本品牌委託崧博出版經銷，官方網站由崧博出版製作',
    url: 'https://sonbook.net/',
  },
  {
    category: '書目查詢',
    name: '書籍資料庫',
    desc: '查詢書名、作者、ISBN 及完整書目資訊',
    url: 'https://catalog.sonbook.net/',
  },
];

export default function HomePartnerSection() {
  const navigate = useNavigate();
  const { ref, isVisible } = useScrollReveal<HTMLElement>({ threshold: 0.1 });

  return (
    <section
      ref={ref}
      className="min-h-[100svh] flex items-center bg-background-50 border-t border-primary-500/8"
    >
      <div className="w-full max-w-[1280px] mx-auto px-6 md:px-10 py-20 md:py-28">
        {/* Section label */}
        <div
          style={getRevealStyle(isVisible, 0)}
          className="flex items-center justify-center gap-4 mb-12 md:mb-16"
        >
          <span className="text-[10px] font-medium text-primary-400 tracking-[0.25em] uppercase font-label">
            Distribution
          </span>
          <div className="w-12 h-px bg-primary-500/30" />
          <span className="text-[10px] font-medium text-primary-400 tracking-[0.25em] uppercase font-label">
            04
          </span>
        </div>

        {/* Centered heading */}
        <h2
          style={getRevealStyle(isVisible, 60)}
          className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-100 leading-[1.1] tracking-tight text-center text-glow"
        >
          機曜文化合作購書通路
        </h2>
        <p
          style={getRevealStyle(isVisible, 80)}
          className="mt-4 text-sm text-foreground-400 leading-[1.9] text-center max-w-[640px] mx-auto"
        >
          機曜文化相關書籍可透過網站已建立的合作通路查找與購買。各作品在不同平台的上架狀態、版本、價格及庫存可能不同，實際資訊請以各通路頁面為準。
        </p>
        <div
          style={getRevealStyle(isVisible, 100)}
          className="mt-5 w-12 h-0.5 bg-primary-500 mx-auto shadow-[0_0_8px_var(--tw-shadow-color)] shadow-primary-500/40"
        />

        {/* Cards */}
        <div
          style={getRevealStyle(isVisible, 140)}
          className="mt-12 md:mt-16 max-w-[720px] mx-auto space-y-4"
        >
          {featuredChannels.map((item) => (
            <a
              key={item.name}
              href={item.url}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="group flex items-center justify-between border border-primary-500/10 bg-background-100 px-6 py-6 hover:border-primary-500/40 hover:bg-primary-500/5 hover:shadow-[0_0_24px_var(--tw-shadow-color)] hover:shadow-primary-500/6 transition-all duration-200 cursor-pointer"
            >
              <div>
                <p className="text-xs text-primary-400 tracking-widest uppercase mb-1.5 font-label">
                  {item.category}
                </p>
                <h3 className="text-base font-medium text-foreground-200">
                  {item.name}
                </h3>
                <p className="mt-1 text-sm text-foreground-500">
                  {item.desc}
                </p>
              </div>
              <i className="ri-arrow-right-up-line text-lg text-foreground-700 group-hover:text-primary-400 transition-colors" />
            </a>
          ))}
        </div>

        {/* Cannot find books note */}
        <p
          style={getRevealStyle(isVisible, 180)}
          className="mt-8 text-xs text-foreground-600 leading-[1.8] max-w-[640px] mx-auto text-center"
        >
          若在特定平台找不到書籍，建議先至崧博出版書籍資料庫確認正式書名、作者與 ISBN，再前往其他已建立的合作通路查找。
        </p>

        {/* Link to stores page */}
        <div
          style={getRevealStyle(isVisible, 220)}
          className="mt-8 flex justify-center"
        >
          <button
            onClick={() => navigate('/stores')}
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-400 border-b border-primary-500/30 pb-0.5 hover:text-primary-300 hover:border-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            查看全部合作通路
            <i className="ri-arrow-right-line text-xs" />
          </button>
        </div>
      </div>
    </section>
  );
}